import {Route} from "vue-router";
import {SessionGetParams} from "@share/auth/enums/SessionGetParams";

export const hasSessionParams = (route: Route) => {
    return route.query[SessionGetParams.SessionData] && route.query[SessionGetParams.DecryptionKey];
}